module.exports = "/images/cover-4.jpg";